// extracted by mini-css-extract-plugin
export default {"LabelLink":"FilterLabel_LabelLink__pgJSw","LabelLinkSelected":"FilterLabel_LabelLinkSelected__A7Kmd"};